<template>
  <div class="flex flex-col gap-2">
    <template v-if="documents.length > 0">
      <div
        class="flex items-center gap-4 rounded-xs px-4 py-3 border border-gray-300"
        v-for="document in documents"
        :key="document.id"
      >
        <Assignment class="w-6 h-6" />
        <div class="flex-grow">
          <p class="font-medium leading-5">
            {{ document.title || document?.file?.name }}
          </p>
        </div>
        <Eye
          class="w-6 h-6 pointer hover:opacity-60 text-gray-900"
          @click="downloadFile(document.file?.urls?.file)"
        />
      </div>
      <div
        v-if="canAddFiles"
        @click="openAddDocument = true"
        class="flex items-center gap-4 rounded-xs px-4 py-3 border border-dashed border-gray-300 cursor-pointer hover:text-gray-900 text-gray-500 hover:border-gray-900"
      >
        <PlusIcon class="w-4 h-4 text-inherit" />
        <span>{{ t("components.empty_states.asset.documents.action") }}</span>
      </div>
    </template>
    <NoResults
      v-else
      image="/images/empty/assets/documents.svg"
      :title="t('components.empty_states.asset.documents.title')"
      :description="t('components.empty_states.asset.documents.description')"
      :button-label="t('components.empty_states.asset.documents.action')"
      :hide-button="!canAddFiles"
      @click="openAddDocument = true"
    />
    <FilesUploadDialog
      class="z-backdrop-reset"
      :open="openAddDocument"
      @update:open="openAddDocument = $event"
      :buildingId="tenant.id"
      :spaceIds="space ? [space.id] : []"
      @filesUploaded="router.reload()"
    />
  </div>
</template>

<script setup>
import { mobileSatisfiesVersion } from "@/Tailwind/Helpers/version";
import { useWebView } from "@/Tailwind/Mixins/useWebView";
import Assignment from "@/Tailwind/Icon/Assignment.vue";
import Eye from "@/Tailwind/Icon/Eye.vue";
import NoResults from "@/Tailwind/Components/ListView/NoResults.vue";
import { useI18n } from "vue-i18n";
import { computed, inject, ref } from "vue";
import PlusIcon from "@/Tailwind/Icon/PlusIcon.vue";
import { router } from "@inertiajs/vue3";
import { FilesUploadDialog } from "@/SharedComponents/FilesUploadDialog";

const { t } = useI18n();

const props = defineProps({
  documents: {
    type: Array,
    required: true,
  },
  tenant: {
    type: Object,
    required: false,
  },
  space: {
    type: Object,
    required: false,
  },
});

const { hasPermission, permissions } = inject("permissions");

const canAddFiles = computed(() => {
  return hasPermission(permissions.createDocument, props.tenant.id);
});

const openAddDocument = ref(undefined);

const documents = computed(() => {
  if (!props.documents) {
    return [];
  }

  return props.documents.map((document) => document);
});

const { runningInWebView, openURL } = useWebView();
const downloadFile = (url) => {
  if (!url) {
    return;
  }

  if (!runningInWebView()) {
    window.open(url, "_blank");
    return;
  }

  if (mobileSatisfiesVersion("2.2.0")) {
    openURL(url);
    return;
  }

  // Fallback for outdated mobile apps.
  window.open(url, "_blank");
};
</script>
